import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '@app/common/global_variables';
import { EditComponent } from '@app/common/templates/edit/edit.component';
import { AccountService } from '@app/services/account.service';
import { CRUDService } from '@app/services/crud.service';
import { TblAbfallartCreateComponent } from '@app/views/stammdaten/tbl_abfallart/create/create.component';
import { TblVolumenCreateComponent } from '@app/views/stammdaten/tbl_volumen/create/create.component';
import PATH from '@assets/routes/routes.json';
import { BreadcrumbService } from '@components/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { TblAbfuhrrhythmusCreateComponent } from '../../tbl_abfuhrrhythmus/create/create.component';
import { TblGefaessStatusCreateComponent } from '../../tbl_gefaess_status/create/create.component';
import { TblGefaessTypCreateComponent } from '../../tbl_gefaess_typ/create/create.component';
import { TblGefaessZustandCreateComponent } from '../../tbl_gefaess_zustand/create/create.component';

@Component({
	templateUrl: '../../../../common/templates/edit/edit.component.html',
	styleUrls: ['../style.scss', '../../../../common/templates/edit/style.scss'],
	providers: [DialogService, MessageService, ConfirmationService]
})
export class TblGefaessEditComponent extends EditComponent {
	constructor(
		public accountService: AccountService,
		public breadcrumbService: BreadcrumbService,
		public confirmationService: ConfirmationService,
		public crudService: CRUDService,
		public dialogService: DialogService,
		public globals: Globals,
		public messageService: MessageService,
		public router: Router,
		public translate: TranslateService,
	) {
		super(accountService, breadcrumbService, confirmationService, crudService, dialogService, globals, messageService, router, translate);

		this.apiUrl = 'TblGefaess';
		this.name = 'MENU.GEFAESS';
		this.url = '/' + PATH.GEFAESS;
		this.fieldgroups.push(
			[
				{ type: 'text', key: 'ankey', required: true, width: 400 },
				{ type: 'text', key: 'bezeichnung', required: false, width: 400 },
				{ type: 'text', key: 'barcode', required: true, width: 400 },
				{ type: 'text', key: 'bemerkung', required: false, width: 400 },
				{ type: 'object', key: 'abfallart_id', required: false, width: 400, apiUrl: 'TblAbfallart', createComponent: TblAbfallartCreateComponent },
				{ type: 'object', key: 'volumen_id', required: false, width: 400, apiUrl: 'TblVolumen', createComponent: TblVolumenCreateComponent },
				{ type: 'object', key: 'typ_id', required: false, width: 400, apiUrl: 'TblGefaessTyp', createComponent: TblGefaessTypCreateComponent },
				{ type: 'object', key: 'zustand_id', required: false, width: 400, apiUrl: 'TblGefaessZustand', createComponent: TblGefaessZustandCreateComponent },
				{ type: 'object', key: 'status_id', required: false, width: 400, apiUrl: 'TblGefaessStatus', createComponent: TblGefaessStatusCreateComponent },
				{ type: 'object', key: 'abfuhrrythmus_id', required: false, width: 400, apiUrl: 'TblAbfuhrrhythmus', createComponent: TblAbfuhrrhythmusCreateComponent },
			]
		);
		this.breadcrumbService.setItems([
			{ label: 'MENU.STAMMDATEN' },
			{ label: this.name, routerLink: [this.url] },
			{ label: 'BREADCRUMBS.EDIT', routerLink: [this.url + '/' + PATH.EDIT + '/' + this.id] }
		]);
	}
}
